<template>
	<div class="item_w" :class="{ 'is-selected': isSelected }" color="primary">
		<v-row no-gutters class="in_wr fill-height pr-1">
			<v-col cols="12" class="flow_details pb-3 pt-5 pl-1 pr-1" style="min-height: 15px">
				<v-row no-gutters class="align-center">
					<v-col class="text-left">
						<v-row no-gutters>
							<v-col cols="auto" style="max-width: 400px">
								<h2 class="flow_name">
									{{ triggeredFlow.workflow.workflow_title }}
								</h2>
								<p class="flow_trigger_details text-overflow-ellipsis">
									Triggered at {{ triggeredFlow.created | formatDate }} <span v-if="triggeringUserText"> By {{ triggeringUserText }}</span>
								</p>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="auto" class="t_status text-center">
						<StatusIndicator :status="triggeredFlow.status" />
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { getTriggeringUserText } from './TaskLogService';

import StatusIndicator from './common/StatusIndicator';

export default {
	name: 'TaskLogListItem',
	components: {
		StatusIndicator,
	},
	props: {
		triggeredFlow: { type: [Object, Number] },
		isSelected: { type: Boolean },
		flowId: { type: Number },
	},
	computed: {
		itemSelected() {
			return this.selectedItem == this.triggeredFlow;
		},
		flowTypeIcon() {
			return 'icon-btn';
		},
		triggeringUserText() {
			return getTriggeringUserText(this.triggeredFlow.user);
		},
	},
	methods: {},
	watch: {},
	data: () => ({}),
};
</script>

<style scoped lang="scss">
.tasks {
	width: 84px;
}

.t_status {
	min-width: 84px;
}

.flow_name {
	font-size: 14px;
	font-weight: 400;
	color: #3e495a;
	letter-spacing: 0.02em;
	line-height: 22px;
}

.flow_trigger_details {
	position: relative;
	top: -1px;
	color: rgba(62, 73, 90, 0.45);
	font-size: 12px;
	letter-spacing: 0.02em;
	font-style: italic;
	letter-spacing: 0.001em;
}

.item_w {
	transition: 0.3s;
	cursor: pointer;
	border-bottom: 1px solid #d3dae9;

	&:hover .in_wr {
		background: var(--hover-bg-color);
		transition: 0.3s;
	}
	&:not(:hover) .in_wr {
		transition: 0.3s;
	}
	&.is-selected .in_wr {
		background: var(--selected-bg-color);
		transition: 0.3s;
	}
	&:active {
		transition: 0.3s;
		filter: brightness(0.9);
	}
}
</style>
